

import React, { useEffect, useState } from "react";
import UserManagment from "../component/UserManagment";
import { Apinames } from "../utils/Apiname";
import {
  addEmployeeService,
  getAllDepartmentsService,
  getUserAllService,
  updateUserAllService,
} from "../services/UsermanagementService";
import { getCookie } from "../utils/Common";

type Props = {};

const UserManagementScreen = (props: Props) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [mainLoading, setMainLoading] = useState<boolean>(true);
  const [alluserList, setAllUserList] = useState<any[]>([]);
  const [allDeparmentList, setAllDeparmentList] = useState<any[]>([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [role, setRole] = useState<string | null>(null);

  // Filter states
  const [searchName, setSearchName] = useState("");
  const [searchEmail, setSearchEmail] = useState("");
  const [searchDepartment, setSearchDepartment] = useState("");
  const [searchStatus, setSearchStatus] = useState("");
  const [searchRole, setSearchRole] = useState("");
  const [errorMsg, setErrorMsg] = useState("");


  const [filteredUserList, setFilteredUserList] = useState<any[]>([]);

  useEffect(() => {
    getAllUser();
    getAlldepartments();
    const cookie: any = getCookie("data");
    setRole(cookie.role || null);
  }, []);

  useEffect(() => {
    const filtered = alluserList.filter((user) => {
      const nameMatch =
        !searchName ||
        user.name?.toLowerCase().includes(searchName.toLowerCase());

      const emailMatch =
        !searchEmail ||
        user.email?.toLowerCase().includes(searchEmail.toLowerCase());

      const departmentMatch =
        !searchDepartment ||
        user.department?.toLowerCase().includes(searchDepartment.toLowerCase());

      const statusMatch =
        !searchStatus ||
        user.status?.toLowerCase().includes(searchStatus.toLowerCase());

      const roleMatch =
        !searchRole || searchRole === "ALL" || user.role === searchRole;

      return (
        nameMatch && emailMatch && departmentMatch && statusMatch && roleMatch
      );
    });
    setFilteredUserList(filtered);
  }, [
    alluserList,
    searchName,
    searchEmail,
    searchDepartment,
    searchStatus,
    searchRole,
  ]);

  const getAllUser = async () => {
    try {
      const response = await getUserAllService(Apinames.usersAll);
      if (response?.result) {
        setAllUserList(response?.result);
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
    } finally {
      setMainLoading(false);
    }
  };

  const getAlldepartments = async () => {
    try {
      const response = await getAllDepartmentsService(Apinames.lovDepartments);
      if (response?.result) {
        setAllDeparmentList(response?.result);
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
    } finally {
      setMainLoading(false);
    }
  };

  const onPressAddEmployee = async (values: any) => {
    try {
      setLoading(true);
      let data = {
        email: values.email,
        password: values.password,
        department: values.department,
        name: values.name,
        type: values.type,
      };
      const response = await addEmployeeService(
        Apinames.usersAddEmployee,
        data
      );
      if (response?.result) {
        getAllUser();
        getAlldepartments();
        onPressHandleModal();
      }
    } catch (error) {
      console.log("Error in handleSubmit:", error);
      setErrorMsg(error instanceof Error ? error.message : String(error))
    } finally {
      setLoading(false);
    }
  };

  const updateUserStatus = async (values: any) => {
    try {
      setLoading(true);
      let data = {
        userId: values.id,
        status: values.status,
      };
      const response = await updateUserAllService(
        Apinames.usersupdateStatus,
        data
      );
      if (response?.result) {
        getAllUser();
      }
    } catch (error) {
      console.log("Error in handleSubmit:", error);
    } finally {
      setLoading(false);
    }
  };

  const onPressHandleModal = () => setShowAddModal(!showAddModal);

  return (
    <UserManagment
      loading={loading}
      mainLoading={mainLoading}
      alluserList={filteredUserList}
      role={role}
      errorMsg={errorMsg}
      onPressAddEmployee={onPressAddEmployee}
      showAddModal={showAddModal}
      onPressHandleModal={onPressHandleModal}
      updateUserStatus={updateUserStatus}
      allDeparmentList={allDeparmentList}
      searchName={searchName}
      setSearchName={setSearchName}
      searchEmail={searchEmail}
      setSearchEmail={setSearchEmail}
      searchDepartment={searchDepartment}
      setSearchDepartment={setSearchDepartment}
      searchStatus={searchStatus}
      setSearchStatus={setSearchStatus}
      searchRole={searchRole}
      setSearchRole={setSearchRole}
    />
  );
};

export default UserManagementScreen;
